import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NavService {
    showMobileNav: boolean = false;
}
